<div class="cell-wrapper">
  <!-- Dotted placeholder visible behind the cell when dragging -->
  <div class="placeholder" *ngIf="isLongPress || isDragging"></div>

  <div class="cell" 
       [attr.data-record-id]="recordId"
       [class.cell-dragging]="isLongPress || isDragging" 
       [class.cell-pcr-change]="styleState==='pcr-change'" 
       [class.cell-cancelled]="styleState==='cancelled'"
       (touchstart)="onTouchStart($event)"
       (touchmove)="onTouchMove($event)"
       (touchend)="onTouchEnd()"
       (touchcancel)="onTouchCancel()"
       (mousedown)="onMouseDown($event)">
  
  <!-- Drag handle (4 dots) - only visible during long press -->
  <div class="drag-handle" *ngIf="isLongPress || isDragging">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>

  <div class="cell-content">
    <div class="cell-header">
      <div class="load-number">{{ loadNumber }}</div>
      <button class="expand-btn" type="button" (click)="onToggleExpand()" *ngIf="!isLongPress && !isDragging">
        <img src="/assets/images/Expand_Chevron.png" alt="Expand" class="expand-icon" [class.rotated]="isExpanded()">
      </button>
    </div>

    <!-- Single meta-row with grower, variety, and bulker -->
    <div class="meta-row">
      <img class="meta-icon" src="/assets/images/Grower_Icon.png" alt="Grower">
      <span class="meta-text grower">{{ vendorName }}</span>
      <span class="meta-sep" aria-hidden="true"></span>
      <img class="meta-icon" src="/assets/images/Plant_Variety.png" alt="Variety">
      <span class="meta-text variety">{{ variety }}</span>
      <span class="meta-sep" aria-hidden="true"></span>
      <img class="meta-icon" src="/assets/images/Bulker_Icon.png" alt="Bulker">
      <span class="meta-text bulker">{{ bulker }}</span>
    </div>

    <!-- Scheduled Delivery -->
    <div class="info-section">
      <div class="sched-row">
        <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
        <span class="sched-label">Scheduled Delivery - </span>
        <span class="sched-value">{{ formattedScheduledDelivery }}</span>
      </div>
    </div>

    <div *ngIf="isExpanded()" class="details">
      <app-passport-details 
        [person]="{ 
          passportID: recordId, 
          vendorNumber: vendorNumber, 
          origin: origin, 
          destination: destination, 
          apn: apn, 
          apnName: apnName, 
          vendorName: vendorName, 
          haulier: haulier 
        }" 
        [mode]="'view'" 
        (add)="openDetails()" 
        (history)="openHistory()" 
        (comments)="openComments()" 
        [primaryLabel]="'View'" 
        [hideAdd]="false">
      </app-passport-details>
    </div>
  </div>
</div>
</div>

